<script lang="ts">
    import {
        getOptionValues,
        getProductVariantsThatDifferInOptions,
        mapVariantImages,
    } from "../../../functions/helper/product"
    import ProductColorPreviewList from "./ProductColorPreviewList.svelte"
    import ToggleFavorite from "./ToggleFavorite.svelte"
    import ProductSummary from "./ProductSummary.svelte"
    import { spaLink } from "../../../actions"

    export let product: BKDFProduct,
        shownImage = product.featuredImage

    const variants = getProductVariantsThatDifferInOptions(["Farbe"], product.variants),
        variantImageMappedObject = mapVariantImages(product, variants)
    let currentVariant = variants[0],
        hover = false

    function handleMouseOver() {
        hover = true
        shownImage = variantImageMappedObject[currentVariant.id][1]
    }

    function handleMouseLeave() {
        hover = false
        shownImage = variantImageMappedObject[currentVariant.id][0]
    }

    function handleColorChange(event: CustomEvent) {
        currentVariant = variants.find(
            (v) => v.selectedOptions.find((o) => o.name === "Farbe")?.value === event.detail.color
        )
        shownImage = variantImageMappedObject[currentVariant.id][0]
    }
</script>

<li class="product-preview">
    <section
        class="productImage"
        role="button"
        tabindex="0"
        on:focus
        on:mouseover="{handleMouseOver}"
        on:mouseleave="{handleMouseLeave}"
    >
        <div
            role="dialog"
            class:active="{hover}"
        >
            <div class="favorite">
                <ToggleFavorite productId="{product.id}" />
                <img
                    src="../../../../media/topRightCrinkleBrightAndUnedged.svg"
                    alt="crinkle"
                />
            </div>
            <div class="sizing">
                <em>CHOOSE YOUR STYLE</em>
                <ul>
                    {#each getOptionValues(product, "Größe") as size}
                        <li>{size}</li>
                    {/each}
                </ul>
            </div>
        </div>
        <div>
            <a
                href="/product{product.handle}"
                use:spaLink
                on:focus
            >
                <img
                    src="{shownImage?.url}"
                    alt="{shownImage?.altText}"
                />
            </a>
        </div>
    </section>

    <ProductColorPreviewList
        variants="{variants}"
        bind:currentVariant="{currentVariant}"
        backgroundColor="black"
        on:colorChange="{handleColorChange}"
    />

    <ProductSummary product="{product}" />
</li>

<style lang="less">
    .product-preview {
        width: 28rem;
        flex-shrink: 0;
        height: 33rem;
        display: flex;
        flex-direction: column;

        .productImage {
            position: relative;

            a {
                height: 23.4rem;
                width: 100%;
                display: flex;
                img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                }
            }
            div[role="dialog"] {
                position: absolute;
                overflow: hidden;
                top: 0px;
                right: 0px;
                height: 3.6rem;
                width: 3.6rem;
                display: flex;
                justify-content: flex-end;
                align-items: flex-start;
                img {
                    width: 2.4rem;
                    height: 2.4rem;
                }

                .favorite {
                    height: 3.6rem;
                    position: relative;
                    width: 3.6rem;
                    display: flex;
                    justify-content: flex-end;
                    align-items: flex-start;
                    z-index: 100;

                    img {
                        position: absolute;
                        top: 0px;
                        right: 0px;
                        height: 100%;
                        width: 100%;
                        object-fit: cover;
                    }
                }
                .sizing {
                    background: rgba(13, 12, 12, 0.5);
                    padding: 0.6rem 0rem 0.6rem 0rem;
                    display: flex;
                    z-index: 99;
                    width: 100%;
                    right: -100%;
                    position: absolute;
                    height: 100%;
                    justify-content: center;
                    align-items: center;
                    flex-direction: column;
                    gap: 0.6rem;
                    overflow: hidden;
                    em {
                        color: var(--text-100);
                        font-weight: 700;
                        font-style: normal;
                        font-size: 0.7rem;
                        line-height: 0.7rem;
                        font-family: Outfit-Bold, sans-serif;
                    }
                    ul {
                        display: flex;
                        justify-content: center;
                        li {
                            padding: 0.3rem 0.6rem 0.3rem 0.6rem;
                            border-right: 1px solid var(--text-100);
                            &:last-child {
                                border-right: none;
                            }
                            color: var(--text-100);
                            &:hover {
                                color: var(--text-invers-100);
                                background-color: var(--text-100);
                            }
                        }
                    }
                }

                &.active {
                    width: 100%;
                    .sizing {
                        right: 0;
                    }
                }
            }
        }
    }
</style>
